export const LOAD_OUTSTANDING_ORDER = 'neo-trading/dashboard/LOAD_OUTSTANDING_ORDER';
export const LOAD_OUTSTANDING_ORDER_SUCCESS = 'neo-trading/dashboard/LOAD_OUTSTANDING_ORDER_SUCCESS';
export const LOAD_OUTSTANDING_ORDER_FAILURE = 'neo-trading/dashboard/LOAD_OUTSTANDING_ORDER_FAILURE';
export const GET_ALL_BM='neo-trading/tradepanel/GET_ALL_BM';
export const GET_ALL_BM_SUCCESS='neo-trading/tradepanel/GET_ALL_BM_SUCCESS';
export const GET_ALL_BM_FAILURE='neo-trading/tradepanel/GET_ALL_BM_FAILURE';
export const LOAD_LMTMODIFYPOPUP_FLAG='neo-trading/dashboard/LOAD_LMTMODIFYPOPUP_FLAG';
export const LOAD_OPENTRADEMODIFYPOPUP_FLAG='neo-trading/dashboard/LOAD_OPENTRADEMODIFYPOPUP_FLAG';
export const ALLOCATE_QUANTITY='neo-trading/dashboard/ALLOCATE_QUANTITY';
export const ALLOCATE_QUANTITY_SUCCESS='neo-trading/dashboard/ALLOCATE_QUANTITY_SUCCESS';
export const ALLOCATE_QUANTITY_FAILURE='neo-trading/dashboard/ALLOCATE_QUANTITY_FAILURE';
export const GET_PHYSICALS='neo-trading/dashboard/GET_PHYSICALS';
export const GET_PHYSICALS_SUCCESS='neo-trading/dashboard/GET_PHYSICALS_SUCCESS';
export const GET_PHYSICALS_FAILURE='neo-trading/dashboard/GET_PHYSICALS_FAILURE';
export const LOAD_FIXMODIFYPOPUP_FLAG='neo-trading/dashboard/LOAD_FIXMODIFYPOPUP_FLAG';
export const CHANGE_COMMDTY = 'neo-trading/tradepanel/CHANGE_COMMDTY';
